module.exports = __webpack_public_path__ + "images/button_import_leads.gif";